import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './index.scss';
import IconCircleClose from '../../../../components/IconCircleClose';
import { withNotificationStorageContext } from '../../../../hocs/NotificationStorage';
import { textWhite, textBlack } from '../../../../../styles/scss/_colors.scss';
import IconCopy from '../../../../components/IconCopy';
import IconImportant from '../../../../components/IconImportant';
import IconAlert from '../../../../components/IconAlert';
import IconStarStroke from '../../../../components/IconStarStroke';

import {
    NOTIFICATION_TYPE_INFO,
    NOTIFICATION_TYPE_COPIED,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR,
} from '../../../../../config/consts';

class TopNotification extends Component {
    handleRemoveTopNotification = () => {
        const { notification } = this.props;

        notification.removeNotification(notification.stack.length);
    };

    static returnIcon(type) {
        switch (type) {
            case NOTIFICATION_TYPE_INFO: {
                return <IconStarStroke fill={textWhite} width={20} height={20} />;
            }
            case NOTIFICATION_TYPE_COPIED: {
                return <IconCopy fill={textWhite} width={20} height={20} />;
            }
            case NOTIFICATION_TYPE_WARNING: {
                return <IconImportant fill={textBlack} width={20} height={20} />;
            }
            case NOTIFICATION_TYPE_ERROR: {
                return <IconAlert fill={textWhite} width={20} height={20} />;
            }
            default: {
                return null;
            }
        }
    }

    render() {
        const {
            notification: { stack },
        } = this.props;

        const { type = '', message = '' } = stack.length > 0 ? stack[stack.length - 1] : {};

        const TopNotificationContainerClasses = classnames({
            [styles.topNotification]: true,
            [styles.topNotification_info]:
                type === NOTIFICATION_TYPE_INFO || type === NOTIFICATION_TYPE_COPIED,
            [styles.topNotification_error]: type === NOTIFICATION_TYPE_ERROR,
            [styles.topNotification_warning]: type === NOTIFICATION_TYPE_WARNING,
        });

        return type && type.length ? (
            <div className={TopNotificationContainerClasses}>
                <div className={styles.topNotification__content}>
                    <div className={styles.topNotification__text}>
                        {TopNotification.returnIcon(type)}
                        {message}
                    </div>
                    <button
                        onClick={this.handleRemoveTopNotification}
                        className={styles.topNotification__close}
                    >
                        <IconCircleClose className={styles.closeIcon} />
                    </button>
                </div>
            </div>
        ) : null;
    }
}

TopNotification.propTypes = {
    notification: PropTypes.shape({
        stack: PropTypes.array.isRequired,
        addNotification: PropTypes.func.isRequired,
        removeNotification: PropTypes.func.isRequired,
    }),
};

export default withNotificationStorageContext(TopNotification);
